import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import StatusIcon from 'modules/common/components/StatusIcon';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';

function PropertyDetailsModal({ data, id, history }) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const applicationRedirect = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    history.push(`/rpt/land/applications/${id}`);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Modal.Body>
      <div className="card-content-listing pt-0" style={{height: "80vh", overflowY: "scroll", overflowX: "hidden"}}>
        <div className="row d-flex mb-1 p-3 pr-5">
          <div className="col-12">
            <table className="transaction-table table table-borderless table-striped table-sm ">
              <tbody>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Application Status
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    <span className="p-0">
                      <StatusIcon value={_.get(data, 'status')} />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Transaction Name
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'transaction_code_name') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    ARP No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'arp_no') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    TDN
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'tdn') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    PIN
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'pin') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    OCT/TCT/CLOA No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'oct_tct_cloa_no') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    OCT/TCT/CLOA Date
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'oct_tct_cloa_dated') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Survey No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'survey_no') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Date
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'registered') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Lot No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'lot_no') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Blk
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'blk') || '--'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-12 my-2 border-top" />
          <div className="col-12 mt-3">
            <table className="transaction-table table table-borderless table-striped table-sm ">
              <tbody>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Administrator / Beneficial User
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    {_.get(data, 'administrator_beneficial_user') || '--'}
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Address
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    {_.get(data, 'administrator_beneficial_address') || '--'}
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Tel No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    {_.get(data, 'administrator_beneficial_telephone_no') ||
                      '--'}
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Tax Identification Number
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'administrator_beneficial_tin') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Effectivity of Assessment / Reassessment QTR
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    {_.get(
                      data,
                      'effectivity_of_assessment_reassessment_qtr'
                    ) || '--'}
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Effectivity of Assessment / Reassessment Year
                  </td>
                  <td className="text-dark" width="1" />
                  <td>
                    {_.get(data, 'effectivity_of_assessment_reassessment_yr') ||
                      '--'}
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Appraised/Assessed By
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'appraised_assessed_by') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Appraised/Assessed At
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'appraised_assessed_at') || '--'}</td>
                </tr>

                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Recommended By
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'recommending_by') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Recommended At
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'recommending_at') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Approved By
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'approved_by') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Approved At
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'approved_at') || '--'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-12">
            <table className="transaction-table table table-borderless table-striped table-sm ">
              <tbody>
                <tr className="cms-bg-color-primary-light">
                  <td className="title-color" colSpan={3}>
                    Property Location
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Location
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_location_name') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Province
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_province_name') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    District
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_district_name') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Barangay
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_barangay_name') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Street
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_street') || '--'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-12">
            <table className="transaction-table table table-borderless table-striped table-sm ">
              <tbody>
                <tr className="cms-bg-color-primary-light">
                  <td className="title-color" colSpan={3}>
                    Boundaries
                  </td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    North
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_boundaries_north') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    South
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_boundaries_south') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    East
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_boundaries_east') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    West
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(data, 'property_boundaries_west') || '--'}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width={300}>
                    Sketch
                  </td>
                </tr>
                <tr className="bg-white">
                  <td
                    className="span-title2 font-weight-bold"
                    width={300}
                    colSpan={2}
                  />
                  <td>
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(
                            data,
                            'property_boundaries_land_sketch_photo_url'
                          ) || ''
                        )
                          ? _.get(
                              data,
                              'property_boundaries_land_sketch_photo_url'
                            ) || ImagePlaceholder
                          : _.get(
                              data,
                              'property_boundaries_land_sketch_photo_url.cdnUrl'
                            ) || ImagePlaceholder
                      }
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 mr-3 btn btn-dark "
          >
            <span className="font-weight-bold">Close</span>
          </button>
          <button
            type="button"
            onClick={applicationRedirect}
            className="mt-3 mr-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Go to Application</span>
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

PropertyDetailsModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PropertyDetailsModal);
